import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetCalendarDataRequest,
  GetCalendarDataResponse,
  GetCalendarDataJSONRequest,
  GetCalendarDataJSONResponse,
  GetDailyDataJSONRequest,
  GetDailyDataJSONResponse,
} from "../../models/Calendar.model";
import { environment } from "../../environments";

const API_BASE_URL = environment.apiUrl;

// הפונקציה הקיימת - fetchCalendarEvents
export const fetchCalendarEvents = createAsyncThunk(
  "calendar/fetchEvents",
  async (params: {
    token: string;
    companyKey: string;
    startDate: string;
    endDate: string;
  }) => {
    // כאן תהיה הלוגיקה הקיימת של fetchCalendarEvents
    // אני מניח שהיא דומה ל-getCalendarData
    const response = await fetch(`${API_BASE_URL}Calendar/GetEvents`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Token: params.token,
        CompanyKey: params.companyKey,
        StartDate: params.startDate,
        EndDate: params.endDate,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }
);

// הפונקציה החדשה - getCalendarData
export const getCalendarData = createAsyncThunk<
  GetCalendarDataResponse,
  GetCalendarDataRequest,
  { rejectValue: string }
>("calendar/getCalendarData", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(`${API_BASE_URL}Calendar/GetCalendarData`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Token: request.token,
        CompanyKey: request.companyKey,
        StartDate: request.startDate,
        EndDate: request.endDate,
      }),
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("אין הרשאה לבצע פעולה זו");
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: GetCalendarDataResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error in getCalendarData:", error);
    return rejectWithValue(
      error instanceof Error ? error.message : "שגיאה בטעינת נתוני לוח שנה"
    );
  }
});

// עוזר תזמון - קריאה נפרדת
export const getCalendarDataForAssistant = createAsyncThunk<
  GetCalendarDataResponse,
  GetCalendarDataRequest,
  { rejectValue: string }
>(
  "calendar/getCalendarDataForAssistant",
  async (request, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE_URL}Calendar/GetCalendarData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Token: request.token,
          CompanyKey: request.companyKey,
          StartDate: request.startDate,
          EndDate: request.endDate,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: GetCalendarDataResponse = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "שגיאה בטעינת נתוני עוזר תזמון"
      );
    }
  }
);

// פונקציה חדשה - getCalendarDataJSON
export const getCalendarDataJSON = createAsyncThunk<
  GetCalendarDataJSONResponse,
  GetCalendarDataJSONRequest,
  { rejectValue: string }
>("calendar/getCalendarDataJSON", async (request, { rejectWithValue }) => {
  try {

    const response = await fetch(
      `${API_BASE_URL}Calendar/GetCalendarDataJSON`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Token: request.token,
          CompanyKey: request.companyKey,
          StartDate: request.startDate,
          EndDate: request.endDate,
        }),
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("אין הרשאה לבצע פעולה זו");
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: GetCalendarDataJSONResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error in getCalendarDataJSON:", error);
    return rejectWithValue(
      error instanceof Error ? error.message : "שגיאה בטעינת נתוני לוח שנה JSON"
    );
  }
});
export const getDailyDataJSON = createAsyncThunk<
  GetDailyDataJSONResponse,
  GetDailyDataJSONRequest,
  { rejectValue: string }
>("calendar/getDailyDataJSON", async (request, { rejectWithValue }) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}Calendar/GetDailyDataJSON`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      }
    );

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error("אין הרשאה לבצע פעולה זו");
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: GetDailyDataJSONResponse = await response.json();
    return data;
  } catch (error) {
    console.error("Error in getCalendarDataJSON:", error);
    return rejectWithValue(
      error instanceof Error ? error.message : "שגיאה בטעינת נתוני לוח שנה JSON"
    );
  }
});